/* eslint-disable no-console */
import PasswordRecoveryForm from './PasswordRecoveryForm';

export const Empty = {
  component: PasswordRecoveryForm,
  props: {
    formId: 'PasswordRecoveryFormExample',
    onSubmit(values) {
      
    },
  },
  group: 'forms',
};
